<template>
  <div class="">
    <ul class="tablist">
      <li class="tabmenu current" @click="goPageByName('point')">{{$t('front.point.pointHistory')}}</li>
      <li class="tabmenu" @click="goPageByName('pointuse')">{{$t('front.point.pointChangeApply')}}</li>
      <li class="tabmenu" @click="goPageByName('pointuselist')">{{$t('front.point.convertPoint')}}</li>
    </ul>
    <div class="PTsch">
     <div class="datesearchPT">
        <date-filter @search="loadList(1)"
                     @update="onChangeDate"
                     :startDate="searchDate.startDate"
                     :endDate="searchDate.endDate" />
        <button class="dateBtn" @click="loadList(1)">{{ $t('front.give.search') }}</button>
     </div>
     <div class="datesearchM">
        <date-filter-mobile @search="loadList"
                     @update="onChangeDate" />
        <button class="dateBtn" @click="loadList(1)">{{ $t('front.give.search') }}</button>
     </div>
    </div>

    <div class="strTablescr">
     <div class="strTablePC">
        <table class="strTablePT">
          <colgroup>
            <col width="10%">
            <col width="10%">
            <col width="10%">
            <col width="15%">
            <col width="15%">
            <col width="15%">
            <col width="25%">
          </colgroup>
          <thead>
            <tr>
              <th>{{$t('front.board.accrualDay')}}</th>
              <th>{{$t('front.common.memId')}}</th>
              <th>{{$t('front.board.kind')}}</th>
              <th>{{$t('front.board.betMoney')}}</th>
              <th>{{$t('front.board.percent')}}</th>
              <th>{{$t('front.board.bonusPercent')}}</th>
              <th>{{$t('front.board.accrualPoint')}}</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="list.length > 0">
              <template v-for="item in list" :key="item.gameIdx">
                <tr>
                  <td>{{dateFormatAll(item.regDt)}}</td>
                  <td>{{item.memId}}</td>
                  <td>{{item.codeName}}</td>
                  <td>{{thousand(item.betAmt)}}</td>
                  <td>{{item.pointRate}}%</td>
                  <td>{{item.pointBonusRate}}%</td>
                  <td>{{thousand(item.point_inAmt)}}P</td>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr>
              </tr>
            </template>
          </tbody>
        </table>
     </div>
  </div>
    <pagination
        :pageNum="pageInfo.page"
        :pageSize="pageInfo.count_per_list"
        :totalCount="pageInfo.tatal_list_count"
        @goToPage="loadList" />

  </div>
</template>

<script>
import DateFilter from '@/components/ui/DateFilter'
import DateFilterMobile from '@/components/ui/DateFilterMobile'
import Pagination from '@/components/ui/Pagination'

import { getPointList } from '@/api/point'
export default {
  name: 'pointList',
  components: { DateFilter, DateFilterMobile, Pagination },
  data () {
    return {
      list: [],
      sum: {}
    }
  },
  created () {
    this.loadList()
  },
  methods: {
    loadList (page) {
      const params = {
        pointType: 'in',
        page: page || this.pageInfo.page,
        startDate: this.searchDate.startDate,
        endDate: this.searchDate.endDate
      }

      getPointList(params).then(response => {
        const result = response.data
        if (result.resultCode === '0') {
          if (result.data.pageInfo) {
            this.pageInfo = result.data.pageInfo
          }
          const data = result.data
          this.list = data.list
          this.sum = data.sum
        }
      })
    }
  }
}
</script>
<style scoped>
.boardw li:nth-child(2){word-break: break-all;}
</style>
<style src="@/styles/striNew.css"></style>

<style scoped>
.tablist {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  margin: 22px 0 22px !important;
  padding: 0 !important;
  list-style: none !important;
}

.tablist .tabmenu {
  min-width: 144px;
  height: 38px !important;
  padding: 0 18px !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  color: #111827 !important;
  font-size: 16px;
  font-weight: 800;
  line-height: 38px !important;
  text-align: center !important;
  box-sizing: border-box !important;
  cursor: pointer !important;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.05) !important;
  transition: all 0.18s ease !important;
}

.tablist .tabmenu:hover {
  border-color: #b9c7dc !important;
  background: #f8fafc !important;
}

.tablist .tabmenu.current {
  border-color: #5969d7 !important;
  background: #5969d7 !important;
  color: #ffffff !important;
  box-shadow: 0 8px 16px rgba(89, 105, 215, 0.2) !important;
}

.PTsch {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  min-height: 54px !important;
  margin: 0 0 18px !important;
  padding: 12px 14px !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05) !important;
}

.datesearchPT {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  width: 100% !important;
  min-width: 0 !important;
}

.datesearchM {
  display: none !important;
}

.PTsch :deep(.datesearch),
.PTsch :deep(.dateFilter),
.PTsch :deep(.date-filter) {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  flex-wrap: wrap !important;
}

.PTsch :deep(input),
.PTsch :deep(select) {
  height: 30px !important;
  padding: 0 10px !important;
  border: 1px solid #d4ddeb !important;
  border-radius: 5px !important;
  background: #ffffff !important;
  color: #253044 !important;
  font-size: 13px !important;
  box-sizing: border-box !important;
  outline: none !important;
}

.PTsch :deep(input:focus),
.PTsch :deep(select:focus) {
  border-color: #5b7ee5 !important;
  box-shadow: 0 0 0 3px rgba(91, 126, 229, 0.13) !important;
}

.PTsch :deep(button:not(.dateBtn)) {
  height: 30px !important;
  min-width: 52px !important;
  padding: 0 12px !important;
  border: 1px solid #5f6978 !important;
  border-radius: 4px !important;
  background: #5f6978 !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 800 !important;
}

.dateBtn {
  height: 30px !important;
  min-width: 54px !important;
  margin-left: 4px !important;
  padding: 0 14px !important;
  border: 1px solid #d69400 !important;
  border-radius: 5px !important;
  background: #d69400 !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 900 !important;
  box-shadow: 0 4px 10px rgba(214, 148, 0, 0.16) !important;
  cursor: pointer !important;
}

.strTablescr {
  width: 100% !important;
  margin-top: 6px !important;
  padding: 0 !important;
  overflow: visible !important;
  background: transparent !important;
  border: 0 !important;
}

.strTablePC {
  width: 100% !important;
  overflow: hidden !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05) !important;
}

.strTablePT {
  width: 100% !important;
  border-collapse: collapse !important;
  table-layout: fixed !important;
  background: #ffffff !important;
  color: #1f2937 !important;
  font-size: 13px !important;
}

.strTablePT th,
.strTablePT td {
  height: 43px !important;
  padding: 9px 12px !important;
  border: 0 !important;
  border-bottom: 1px solid #dfe6ef !important;
  color: #1f2937 !important;
  text-align: center !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  box-sizing: border-box !important;
}

.strTablePT th {
  height: 45px !important;
  background: #ffffff !important;
  color: #111827 !important;
  font-weight: 900 !important;
  border-bottom: 1px solid #cfd8e5 !important;
}

.strTablePT thead tr {
  border-top: 3px solid #2f6df6;
  border-radius: 10px 10px 0 0;
}

.strTablePT tbody tr {
  background: #ffffff !important;
}

.strTablePT tbody tr:nth-child(2n) {
  background: #f5f5f6 !important;
}

.strTablePT tbody tr:hover {
  background: #eef6ff !important;
}

.strTablePT tbody tr:last-child td {
  border-bottom: 0 !important;
}

.strTablePT td:nth-child(4),
.strTablePT td:nth-child(7) {
  font-family: Roboto, Arial, sans-serif !important;
  font-weight: 600 !important;
}

.strTablePT td:nth-child(7) {
  color: #1d4ed8 !important;
}

.datesearchM {
  display: none !important;
}

:deep(.partnerPaging),
:deep(.paging),
:deep(.pagination) {
  margin-top: 20px !important;
}

@media (max-width: 1000px) {
  .tablist {
    gap: 8px !important;
    margin: 16px 0 !important;
    overflow-x: auto !important;
  }

  .tablist .tabmenu {
    min-width: 126px;
    height: 36px !important;
    font-size: 14px;
    line-height: 36px !important;
  }

  .datesearchPT {
    display: none !important;
  }

  .datesearchM {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    padding: 12px !important;
    border: 1px solid #dbe3ef !important;
    border-radius: 10px !important;
    background: #ffffff !important;
  }

  .strTablePC {
    overflow-x: auto !important;
  }

  .strTablePT {
    min-width: 820px !important;
  }
}
@media (max-width: 1092px) {
  .tablist .tabmenu{
    width: calc(100% / 3 - 6px);
    white-space: nowrap;
  }
}
@media (max-width: 520px) {
  .tablist .tabmenu{
    font-size: 12px;
    min-width: auto;
  }
}
</style>
